/** tempexp_14728-full-file */
import React, { FC } from 'react';
import { EViewMode } from 'reactApp/modules/settings/settings.types';
import { Checkbox } from 'reactApp/ui/DataListItemCommonComponents/Checkbox/Checkbox';
import { Destination } from 'reactApp/ui/DataListItemCommonComponents/Destination/Destination';
import { Publish } from 'reactApp/ui/DataListItemCommonComponents/Publish/Publish';
import { Access } from 'reactApp/ui/DataListItemRow/components/Access/Access';
import { Invitation } from 'reactApp/ui/DataListItemRow/components/Invitation/Invitation';
import { ItemName } from 'reactApp/ui/DataListItemRow/components/ItemName/ItemName';
import { Pic } from 'reactApp/ui/DataListItemRow/components/Pic/Pic';
import { Size } from 'reactApp/ui/DataListItemRow/components/Size/Size';
import { TableColumn } from 'reactApp/ui/DataListItemRow/components/TableColumn/TableColumn';
import { IncomingItemProps } from 'reactApp/ui/DataListItemRow/DataListItemRow.types';

interface IncomingProps extends IncomingItemProps {
    checkboxClassname?: string;
}

export const Incoming: FC<IncomingProps> = (props) => {
    return (
        <>
            <TableColumn>
                <Checkbox
                    viewType={EViewMode.list}
                    className={props.checkboxClassname}
                    onCheckboxClick={props.onCheckboxClick}
                    isSelected={props.isSelected}
                />
                <Pic isFolder={true} kind={props.kind} author={props.owner} isPublic={props.isPublic} />
            </TableColumn>
            <TableColumn width="100%" overflow="hidden">
                <ItemName name={props.name} id={props.id} />
            </TableColumn>
            <TableColumn minWidth={220} width="100%">
                <Destination destination={props.owner.name} author={props.owner} />
            </TableColumn>
            <TableColumn flexBasis={132} flexShrink={0} justifyContent="flex-end">
                <Access access={props.access} />
            </TableColumn>
            <TableColumn flexBasis={132} flexShrink={0} justifyContent="center">
                <Size size={props.size} />
            </TableColumn>
            <TableColumn flexBasis={128} flexShrink={0} justifyContent="flex-end" gap={20}>
                {props.isMounted ? (
                    <Publish viewType={EViewMode.list} onClick={props.onMount} isShared={true} />
                ) : (
                    <Invitation onAccept={props.onAccept} onReject={props.onReject} />
                )}
            </TableColumn>
        </>
    );
};
